import { useEffect } from "react";
import { imageCacheManager } from "src/lib/sync-box/image-cache/ImageCacheManager";
import syncBoxManager from "src/lib/sync-box/SyncBoxManager";
import getExamLevelSyncBoxes from "../../offline/sync-boxes/examLevel";
const EXAM_LEVEL_VISIT_THRESHOLD = 3;
const getDefaultVisitState = () => ({
    count: 0,
    syncboxRegistered: false,
});
const visitCounter = {};
function incrementVisit(examLevelID) {
    if (!visitCounter[examLevelID]) {
        visitCounter[examLevelID] = getDefaultVisitState();
    }
    visitCounter[examLevelID].count++;
}
function getVisitState(examLevelID) {
    return visitCounter[examLevelID];
}
export default function useVisitHandler(questionID, communityID, examLevelID) {
    useEffect(() => {
        if (communityID && examLevelID) {
            incrementVisit(examLevelID);
            const visitState = getVisitState(examLevelID);
            if (visitState && visitState.count >= EXAM_LEVEL_VISIT_THRESHOLD && !visitState.syncboxRegistered) {
                const examLevelSyncBoxes = getExamLevelSyncBoxes(communityID, examLevelID);
                syncBoxManager.register(examLevelSyncBoxes.subTree, {
                    events: {
                        onSynced() {
                            imageCacheManager.processPendingImages();
                        },
                    },
                });
                syncBoxManager.register(examLevelSyncBoxes.examLevel);
                syncBoxManager.register(examLevelSyncBoxes.community);
            }
        }
    }, [questionID, communityID, examLevelID]);
    useEffect(() => {
        if (communityID && examLevelID) {
            const syncBoxes = getExamLevelSyncBoxes(communityID, examLevelID);
            (async () => {
                const subTreeState = await syncBoxes.subTree.getState();
                const examLevelState = await syncBoxes.examLevel.getState();
                const communityState = await syncBoxes.community.getState();
                await subTreeState.touchLastAccessed();
                await examLevelState.touchLastAccessed();
                await communityState.touchLastAccessed();
            })();
        }
    }, [communityID, examLevelID]);
}
